import React from 'react'

class NavWissensPortal extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M11.6 14h.684c.237-.702.676-1.425 1.288-2.126 1.114-1.275 2.178-3.257 2.178-4.624A5.734 5.734 0 0 0 10 1.5a5.732 5.732 0 0 0-5.75 5.75c0 1.434.418 2.496 1.195 3.483.234.296.988 1.118 1.015 1.15.598.706 1.018 1.421 1.248 2.117H8.6v-4h-.5a1.5 1.5 0 1 1 1.5-1.5V9h1v-.5a1.5 1.5 0 1 1 1.5 1.5h-.5v4zm-1 0v-4h-1v4h1zm-4.113 1.5l-.103-.628c-.099-.598-.454-1.293-1.069-2.02.007.008-.771-.84-1.048-1.191C3.293 10.425 2.75 9.045 2.75 7.25A7.232 7.232 0 0 1 10 0c4.01 0 7.25 3.226 7.25 7.25 0 1.82-1.216 4.086-2.548 5.61-.627.718-1 1.423-1.097 2.012l-.103.628H6.487zm.013 1.3h7v1h-7v-1zM8 19h4v1H8v-1zm.6-10v-.5a.5.5 0 1 0-.5.5h.5zm3 0h.5a.5.5 0 1 0-.5-.5V9z"
        />
      </svg>
    )
  }
}

export default NavWissensPortal
